import { render, staticRenderFns } from "./Piao8.vue?vue&type=template&id=494fdacf&scoped=true&"
import script from "./Piao8.vue?vue&type=script&lang=js&"
export * from "./Piao8.vue?vue&type=script&lang=js&"
import style0 from "./Piao8.vue?vue&type=style&index=0&id=494fdacf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494fdacf",
  null
  
)

export default component.exports